import { FormBaseLayout } from 'modules/components/layer10';
import { UploadDocumentField } from 'modules/components/layer04';
import * as ds from './dataService';
import React from 'react';



export type SaveReportAttachmentProps = {
  id: string;
  clientReportId: string;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SaveReportAttachmentProps) => {
  const form = ds.useFormState(props.clientReportId);
  const [
    fnSave,
    { loading }
  ] = ds.useSaveReportAttachment();
  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={async () => {
        await fnSave({
          id: props.id,
          clientReportId: props.clientReportId ?? '',
          apiFileId: form.formState.apiFileId ?? ''
        });
        props.handleClose();
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >

      <UploadDocumentField.FC
        form={form}
        fieldName='apiFileId'
      />

    </FormBaseLayout.FC>

  );
};
